// A checklist item as the editor serializes it: `li[data-type="taskItem"]`
// carrying its state in `data-checked`, with the checkbox inside its label.
export const TASK_ITEM_SELECTOR = 'li[data-type="taskItem"]';

/**
 * The note body with its `index`-th checklist item (document order) set to
 * `checked`. `data-checked` is the state that round-trips through the
 * sanitizer; the inner input's `checked` attribute follows it. Returns the
 * body unchanged when there is no such item.
 */
export function setTaskItemChecked(
  html: string,
  index: number,
  checked: boolean,
): string {
  const template = document.createElement("template");
  template.innerHTML = html;
  const item = template.content.querySelectorAll(TASK_ITEM_SELECTOR)[index];
  if (!item) return html;
  item.setAttribute("data-checked", String(checked));
  const box = taskItemCheckbox(item);
  if (box) {
    if (checked) box.setAttribute("checked", "checked");
    else box.removeAttribute("checked");
  }
  return template.innerHTML;
}

/** The item's own checkbox — not one belonging to a nested checklist. */
export function taskItemCheckbox(item: Element): HTMLInputElement | null {
  for (const box of Array.from(
    item.querySelectorAll<HTMLInputElement>('input[type="checkbox"]'),
  )) {
    if (box.closest(TASK_ITEM_SELECTOR) === item) return box;
  }
  return null;
}

/** The item's own text, for the checkbox's accessible name. */
export function taskItemLabel(item: Element): string {
  const body = Array.from(item.children).find((el) => el.tagName === "DIV");
  const first = body?.firstElementChild ?? body;
  return first?.textContent?.trim() ?? "";
}
